<template>
    <div class="case-detail">
        <h1>{{ caseInfo.title }}</h1>
        <div class="case-meta">
            <span><i class="fa fa-user"></i> {{ caseInfo.client }}</span>
            <span><i class="fa fa-map-marker"></i> {{ caseInfo.projectLocation }}</span>
            <span><i class="fa fa-calendar"></i> {{ caseInfo.completionTime }}</span>
        </div>
        <div class="case-img">
            <img :src="caseInfo.coverImage" :alt="caseInfo.title">
        </div>
        <div class="case-content">
            <p>{{ caseInfo.description }}</p>
        </div>
        <button @click="$router.go(-1)" class="back-btn">返回列表</button>
    </div>
</template>

<script>
import { caseApi } from '@/api'
export default {
    name: 'CaseDetail',
    data() {
        return {
            caseInfo: {}
        }
    },
    mounted() {
        // 获取路由参数中的案例ID
        const caseId = this.$route.params.id
        this.getCaseDetail(caseId)
    },
    methods: {
        getCaseDetail(id) {
            caseApi.getCaseById(id).then(res => {
                this.caseInfo = res.data
            }).catch(err => {
                console.error('获取案例详情失败:', err)
            })
        }
    }
}
</script>

<style scoped>
.case-detail {
    max-width: 1200px;
    margin: 0 auto;
    padding: 40px 20px;
}
.case-meta {
    margin: 20px 0;
    color: #7f8c8d;
}
.case-meta span {
    margin-right: 20px;
    display: inline-flex;
    align-items: center;
}
.case-meta i {
    margin-right: 5px;
    color: #165DFF;
}
.case-img img {
    width: 100%;
    max-height: 600px;
    object-fit: cover;
    border-radius: 8px;
    margin-bottom: 30px;
}
.case-content {
    line-height: 1.8;
    color: #333;
}
.back-btn {
    margin-top: 30px;
    padding: 8px 20px;
    background-color: #165DFF;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
}
</style>